import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  padding: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  user-select: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Button } from '../button/Button';
import * as DateUtils from './dateUtils';
import DayPicker from './DayPicker';
import { TimePicker } from './TimePicker';
import * as TimeUnit from './timeUnit';
var Modifiers = DateUtils.Modifiers;
var DayPickerWrapper = styled.div(_templateObject());
var DayPickerFooter = styled.div(_templateObject2());
var TimePickerWrapper = styled.div(_templateObject3());
var Divider = styled.div(_templateObject4(), themeGet('calendar.separator.border'));
export var DateTimePicker = function DateTimePicker(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      month = _ref.month,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      canClearSelection = _ref.canClearSelection,
      showActionsBar = _ref.showActionsBar,
      showTimePicker = _ref.showTimePicker,
      precision = _ref.precision,
      required = _ref.required,
      disabled = _ref.disabled,
      isMobile = _ref.isMobile;
  var initialDate = DateUtils.getInitialDate({
    maxDate: maxDate,
    minDate: minDate
  }, value);
  var displayMonth = initialDate.getMonth();
  var displayYear = initialDate.getFullYear();
  var initialMonth = new Date(displayYear, displayMonth);
  var handleDayClick = useCallback(function (day, modifiers, e) {
    e.preventDefault();

    if (modifiers.disabled) {
      return;
    }

    var newValue = canClearSelection && modifiers.selected ? null : DateUtils.getDateTime(day, initialDate);
    onChange(_objectSpread({}, e, {
      target: _objectSpread({}, e.target, {
        value: newValue
      })
    }));
  }, [canClearSelection, initialDate, onChange]);
  var handleTodayClick = useCallback(function (e) {
    e.preventDefault();
    onChange(_objectSpread({}, e, {
      target: _objectSpread({}, e.target, {
        value: new Date()
      })
    }));
  }, [onChange]);
  var handleClear = useCallback(function (e) {
    e.preventDefault();
    onChange(_objectSpread({}, e, {
      target: _objectSpread({}, e.target, {
        value: null
      })
    }));
  }, [onChange]);

  var modifiers = _defineProperty({}, Modifiers.DISABLED, function (day) {
    return !DateUtils.isDayInRange(day, [minDate, maxDate]);
  });

  var disableTodayButton = !DateUtils.isDayInRange(new Date(), [minDate, maxDate]);
  return (
    /*#__PURE__*/
    React.createElement(DayPickerWrapper, null,
    /*#__PURE__*/
    React.createElement(DayPicker, {
      onChange: onChange,
      fromMonth: minDate,
      toMonth: maxDate,
      month: month || initialMonth,
      onDayClick: handleDayClick,
      selectedDays: value || null,
      modifiers: modifiers,
      showOutsideDays: true,
      canChangeMonth: true
    }), showTimePicker &&
    /*#__PURE__*/
    React.createElement(TimePickerWrapper, null,
    /*#__PURE__*/
    React.createElement(TimePicker, {
      date: initialDate,
      onChange: onChange,
      precision: precision,
      isMobile: isMobile
    })), showActionsBar &&
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Divider, null),
    /*#__PURE__*/
    React.createElement(DayPickerFooter, null,
    /*#__PURE__*/
    React.createElement(Button, {
      variant: "link",
      size: "small",
      onClick: handleTodayClick,
      disabled: disableTodayButton || disabled
    }, "Today"),
    /*#__PURE__*/
    React.createElement(Button, {
      variant: "link",
      size: "small",
      onClick: handleClear,
      disabled: disabled || required
    }, "Clear"))))
  );
};
DateTimePicker.defaultProps = {
  maxDate: DateUtils.getDefaultMaxDate(),
  minDate: DateUtils.getDefaultMinDate(),
  precision: TimeUnit.TimePrecision.MINUTE
};